var _style;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTapGesture(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "click",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1835.8 2143.1",
    style: {
      enableBackground: "new 0 0 1835.8 2143.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        .inner, .outer{animation: click 1.4s ease-in-out infinite}\n        .outer{animation-delay:0.7s; }\n        @keyframes click{\n          0%{\n              opacity:1\n          }\n          25%{\n              opacity:0.75\n          }\n          50%{\n              opacity:0.5\n          }\n          75%{\n              opacity:0.25\n          }\n          100%{\n              opacity:0\n          }\n        }\n    ")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "outer",
    style: {
      opacity: 0,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 62.326,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M637.2,969.1C540,907.4,475.5,798.7,475.5,675c0-192.2,155.8-348.1,348.1-348.1s348.1,155.8,348.1,348.1           c0,60.6-15.5,117.6-42.7,167.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "inner",
    style: {
      opacity: 0,
      fill: "none",
      stroke: "#000000",
      strokeWidth: 40.6255,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M638.9,769.6c-14.5-28.4-22.8-60.5-22.8-94.6c0-114.6,92.9-207.4,207.4-207.4S1031,560.5,1031,675c0,38.2-10.3,74-28.4,104.8"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      stroke: "#000000",
      strokeWidth: 65.7953,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "         M1206.1,1251.1c0,0,0-73.8,0-134.1c0-42.7,34.6-77.2,77.6-77.2h1.9c41.4,0,74.9,33.5,74.9,74.9l0,144.6         c0,198.7-33.7,290.4-56.6,329.7c-11.5,19.8-19.9,41.4-24.1,64c-17.5,92.9-99.1,163.2-197.1,163.2H929.8         c-98.4,0-180.3-70.9-197.3-164.6c-4.6-25.2-13.4-49.5-27.3-71l-212.2-331c-28.5-37.7-22.2-91.2,14.3-121.3l0,0         c32.8-27,80.1-26.7,112.7,0.6l121.5,102c0,0,0-385.7,0-554.2c0-42.7,34.6-77.2,77.6-77.2h1.9c41.4,0,74.9,33.5,74.9,74.9l1.2,463.4         v-149c0-42.7,34.6-73.6,77.2-73.6h0c42.7,0,77.2,34.6,77.2,77.2v193.8v-139.6c0-42.7,34.6-77.2,77.2-77.2h0         c42.7,0,77.2,34.6,77.2,77.2V1251.1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTapGesture);
export default __webpack_public_path__ + "static/media/tap_gesture.e04fbfa1e5f382e5ab6aaf3e8c861cc7.svg";
export { ForwardRef as ReactComponent };